import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

import urls from '../../../../../networkRequests/apiClient/endpoints'
import errorHandler from '../../../../../shared/functions/ErrorHandler/errorHandler.functions'
import { ApiErrorResponse } from '../../../../../shared/types/api.types'
import { reassignItemRequestForAdminApi } from './reassignItemRequestForAdmin.api'
import reassignItemRequestForAdminInitialState from './reassignItemRequestForAdmin.initialState'
import {
  ReassignItemRequestForAdminErrorResponse,
  ReassignItemRequestForAdminRequestPayload
} from './reassignItemRequestForAdmin.types'

export const reassignItemRequestForAdmin = createAsyncThunk(
  `${urls.offers.reassignItemRequest}/admin`,
  async (payload: ReassignItemRequestForAdminRequestPayload, { rejectWithValue }) => {
    const { request, onSuccess } = payload

    try {
      const response = await reassignItemRequestForAdminApi(request)

      onSuccess && onSuccess()

      return response
    } catch (error) {
      errorHandler.handleApiError(error as ApiErrorResponse)

      return rejectWithValue(error)
    }
  }
)

const reassignItemRequestForAdminSlice = createSlice({
  name: `${urls.offers.reassignItemRequest}/admin`,
  initialState: reassignItemRequestForAdminInitialState,
  reducers: {
    resetReassignItemRequestForAdmin: (state) => {
      state.loading = false
      state.error = null
      state.success = null
    }

    // Add any additional reducers here
  },
  extraReducers: (builder) => {
    builder
      .addCase(reassignItemRequestForAdmin.pending, (state) => {
        state.loading = true
        state.error = null
        state.success = null
      })
      .addCase(reassignItemRequestForAdmin.fulfilled, (state, { payload }) => {
        state.loading = false
        state.success = payload
        state.error = null
      })
      .addCase(reassignItemRequestForAdmin.rejected, (state, { payload }) => {
        state.loading = false
        state.error = payload as ReassignItemRequestForAdminErrorResponse
        state.success = null
      })
  }
})

export const { actions: reassignItemRequestForAdminActions, reducer: reassignItemRequestForAdminReducer } =
  reassignItemRequestForAdminSlice
export const { resetReassignItemRequestForAdmin } = reassignItemRequestForAdminActions
export default reassignItemRequestForAdminSlice.reducer
